export default "__VITE_ASSET__CoDQW1pZ__"